"use client";

import ProductImageFullscreen from "./product-image-full-screen";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";
interface Props {
    children?: React.ReactNode;
    imageUrl: string | null;
    weightshow: string;
    text: { [key: string]: string };
    imagePriority?: boolean;
    imageAlt?: string;
}

const ProductPromotionImageGallery = ({ children, imageUrl, weightshow, text, imagePriority, imageAlt }: Props) => {
    const colorStyle = useContext(ColorStyleContext);

    return (
        <div className="flexflex-col justify-center  p-0">
            <div className=" relative  rounded-xl bg-grayc4 2xl:min-w-[30rem] xl:min-w-[25rem] md:min-w-[20rem]">
                <ProductImageFullscreen
                    imageUrl={imageUrl ?? ""}
                    className="object-contain"
                    priority={imagePriority}
                    imageAlt={imageAlt}
                />
            </div>
            {children}
        </div>
    );
};

export default ProductPromotionImageGallery;
